import { render, staticRenderFns } from "./MDataSelector.vue?vue&type=template&id=92ca8722&"
import script from "./MDataSelector.vue?vue&type=script&lang=js&"
export * from "./MDataSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports